module.exports = global["Player"] = require("-!/Users/jnunez/git/medscapetv/node_modules/babel-loader/index.js!/Users/jnunez/git/medscapetv/modules/video/video_player.js");


/** WEBPACK FOOTER **
 ** ./modules/video/video_player.js
 **/